import { useFormContext } from "react-hook-form";
import { ActivityRegistrationNumberInput } from "@shared-kernel/primary/shared/activity-registration-number-input/activity-registration-number-input";
import { STRUCTURE_TYPE, STRUCTURE_TYPE_LABELS } from "@user-management-context/read/domain/types/admin/teacher";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { Input } from "@shared-kernel/primary/shared/shadcn/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared-kernel/primary/shared/shadcn/ui/select";
import { AddressBlock } from "@shared-kernel/primary/shared/address-autocomplete/address-block";
import { SiretAutocompleteField } from "@shared-kernel/primary/shared/siret-autocomplete/siret-autocomplete-field";
import { EUROPEAN_COUNTRIES } from "@shared-kernel/domain/types/supported-country";
import type { TeacherOnboardingFormInputs } from "../form-validation/full-form.schema";

export const ActivityStep = () => {
  const { control, watch, setValue } = useFormContext<TeacherOnboardingFormInputs>();

  const structureType = watch("structureType");
  const showBusinessName = structureType === STRUCTURE_TYPE.ASSOCIATION || structureType === STRUCTURE_TYPE.ENTREPRISE;

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="structureType"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Type de structure</FormLabel>
            <Select
              value={field.value}
              onValueChange={value => {
                field.onChange(value);
                if (value === STRUCTURE_TYPE.AUTO_ENTREPRISE) {
                  setValue("businessName", "");
                }
              }}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Sélectionner un type de structure" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {Object.values(STRUCTURE_TYPE).map(type => (
                  <SelectItem key={type} value={type}>
                    {STRUCTURE_TYPE_LABELS[type]}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <AddressBlock
        fields={{
          postalAddress: "postalAddress",
          addressComplement: "addressComplement",
          country: "country",
        }}
        addressLabel="Votre adresse postale"
        countries={EUROPEAN_COUNTRIES}
      />
      <SiretAutocompleteField
        siretFieldName="siret"
        countryFieldName="country"
        nameFieldName={showBusinessName ? "businessName" : undefined}
      />
      {showBusinessName && (
        <FormField
          control={control}
          name="businessName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Raison sociale</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
      <FormField
        control={control}
        name="activityRegistrationNumber"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Numéro de déclaration d&apos;activité</FormLabel>
            <FormControl>
              <ActivityRegistrationNumberInput placeholder="11 chiffres" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
